(function () {

  var WRAPPER_SELECTORS = '.boost-sd__search-bar-wrapper, .boost-sd__search-bar-wrapper--mobile';
  var SEARCH_BAR = '.boost-sd__search-bar';
  var EMPTY_SEARCH = '.empty-search-content';
  var RESULTS_SELECTOR = '.boost-sd__instant-search-results--mobile, .boost-sd__instant-search-results';

  function isTopState() {
    return window.scrollY <= 1;
  }

  function applyEmptySearchPadding(isTop) {
    var paddingValue = isTop ? '50px' : '20px';

    document.querySelectorAll(EMPTY_SEARCH).forEach(function (el) {
      // Native mobile search panel (not hosted by Boost) has its own fixed 20px padding from the Figma design
      var hostedByBoost = el.closest('#boost-sd__search-bar-autocomplete-wrapper, ' + WRAPPER_SELECTORS);
      if (window.innerWidth < 750 && !hostedByBoost) {
        el.style.removeProperty('padding-top');
        return;
      }
      el.style.setProperty('padding-top', paddingValue, 'important');
    });
  }

  function applyResultsPadding(isTop) {
    var paddingValue = isTop ? '40px' : '10px';

    document.querySelectorAll(RESULTS_SELECTOR).forEach(function (el) {
      el.style.setProperty('padding-top', paddingValue, 'important');
    });
  }

  function updateTop() {
    var isDesktop = window.innerWidth >= 768;
    var isTop = isTopState();

    if (isDesktop) {
      var topValue = isTop ? '32px' : '0px';

      document.querySelectorAll(WRAPPER_SELECTORS + ', ' + SEARCH_BAR).forEach(function (el) {
        el.style.setProperty('top', topValue, 'important');
      });

    } else {
      var searchTop = isTop ? '32px' : '0px';

      document.querySelectorAll(SEARCH_BAR).forEach(function (el) {
        el.style.setProperty('top', searchTop, 'important');
      });

      document.querySelectorAll(WRAPPER_SELECTORS).forEach(function (el) {
        el.style.setProperty('top', '0px', 'important');
      });
    }

    applyEmptySearchPadding(isTop);
    applyResultsPadding(isTop);
  }

  window.addEventListener('load', function () {
    requestAnimationFrame(updateTop);
  });

  // Scroll
  window.addEventListener('scroll', updateTop, { passive: true });

  // Resize
  window.addEventListener('resize', updateTop);

  const observer = new MutationObserver(function (mutations) {
    requestAnimationFrame(updateTop);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();